import { render, staticRenderFns } from "./integralMall.vue?vue&type=template&id=2683b06e&scoped=true"
import script from "./integralMall.vue?vue&type=script&lang=js"
export * from "./integralMall.vue?vue&type=script&lang=js"
import style0 from "./integralMall.vue?vue&type=style&index=0&id=2683b06e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2683b06e",
  null
  
)

export default component.exports